<template>
  <div style="height: 855px">
    <a-row :style="{padding: onMobile? '3px 10px':'0px'}" type="flex" justify="space-between">
      <!--左侧留白-->
      <a-col :span="4" style="height: 100%"/>
      <a-col :span="16" style="padding-top: 10px">
        <a-col :span="24" style="background-color: #fff;margin-bottom: 20px;border-radius: 5px">
          <a-card hoverable>
            <a-row>
              <a-col :span="3">
                <div style="text-align: center">
                  <a-avatar :size="100" slot="avatar" :src="userInfo.avatar"/>
                </div>
              </a-col>
              <a-col :span="18">
                <div style="font-size: 22px">{{ userInfo.name }}</div>
                <div>自我介绍: 这个用户很神秘~</div>
                <div>生日: {{ moment(userInfo.birthday).format('YYYY年MM月DD日') }}</div>
                <div>IP属地: {{ userInfo['lastCity'] ? userInfo['lastCity'] : '未知星域' }}</div>
              </a-col>
              <a-col :span="3">
                <div style="text-align: center" v-if="!currentUser">
                  <a-button :disabled="followed" type="primary" size="large" style="width: 120px"
                            @click="followEvent(userInfo.id)">{{ followed ? '已关注' : '关注' }}
                  </a-button>
                </div>
              </a-col>
            </a-row>
          </a-card>
        </a-col>

        <a-col :span="onMobile? 24:6" style="padding-right: 20px;">
          <a-card hoverable>
            <a-col style="height: 115px;">
              <div style="height: 30px">
                <span style="font-size: 22px;">{{
                    currentUser ? '我的等级' : 'TA的等级'
                  }}:   登堂入室</span>
              </div>
              <div style="width: 100%;height: calc(100% - 30px);">
                <div
                    style="height:calc(100% - 10px);margin: 10px 0;background-color: rgba(255,213,145,0.15);font-size: 18px">
                  ☀🌏🌙🌙⭐⭐⭐
                </div>
              </div>
            </a-col>
          </a-card>
          <a-col class="personal-summary-container">
            <a-card hoverable>
              <a-layout>
                <a-layout-header>
                  <span style="font-weight: bold;font-size: 22px;">{{ currentUser ? '我的专栏' : 'TA的专栏' }}</span>
                </a-layout-header>
                <a-layout-content style="padding:0 5px;overflow:auto;background-color: rgb(255,255,255)">
                  <a-list :loading="loading" item-layout="horizontal" :data-source="summaryData">
                    <a-list-item slot="renderItem" slot-scope="item, index">
                      <a-list-item-meta :description="item.createTime">
                        <a slot="title" style="font-weight: bold;font-size: 15px">{{ item.blogName }}</a>
                      </a-list-item-meta>
                    </a-list-item>
                  </a-list>
                </a-layout-content>
              </a-layout>
            </a-card>
          </a-col>
        </a-col>
        <a-col :span="onMobile? 24:18" :style="{paddingLeft: onMobile?'0':'20px'}">
          <a-card hoverable>
            <a-list item-layout="vertical" :data-source="listData" class="personal-container">
              <!--            <a-list item-layout="vertical" :data-source="listData" class="personal-container" :pagination="pagination">-->
              <a-list-item slot="renderItem" key="item.id" slot-scope="item, index">
                <img slot="extra" :width="$store.state.screenWidth < 576?'100%':200" alt="logo"
                     :src="item.cover ? item.cover : 'https://i.loli.net/2021/11/15/RILk3osTvBYtzwW.jpg'"
                />
                <a-list-item-meta :description="item.description" style="margin-bottom:0">
                  <a slot="title" @click="showDetail(item.id)">{{ item.name }}</a>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-card>
        </a-col>
      </a-col>
      <!--右侧留白-->
      <a-col :span="4" style="height: 100%"/>

    </a-row>
  </div>
</template>

<script>
import BlogRequest from "@/store/RequestModules/BlogRequest";
import UserInfoRequest from "@/store/RequestModules/UserInfoRequest";
import moment from "moment";
import UserEventRequest from "@/store/RequestModules/UserEventRequest";

export default {
  name: "PersonalHomepage",
  data() {
    return {
      onMobile: this.$store.state.screenWidth < 576,
      listData: [],
      pagination: {
        onChange: page => {
          this.searchBlog({pageNum: page})
        },
        pageSize: 10,
        total: 0
      },
      userInfo: this.$store.state.userInfo,
      currentUser: true,
      loading: false,
      summaryData: [],
      followed: true,
    };
  },
  methods: {
    moment,
    searchBlog(param) {
      if (this.selectedType && this.selectedType != "ALL") {
        param.blogType = this.selectedType
      }
      BlogRequest.searchBlog(param).then(res => {
        if (res.status == '200' && res.data.data) {
          this.listData = res.data.data.list
          this.pagination.total = res.data.data.total
        }
      })
    },
    searchBlogSummary(param) {
      BlogRequest.getUserBlog(param).then(res => {
        if (res.status == '200') {
          this.summaryData = res.data.data
        }
      })
    },
    showDetail(id) {
      this.$router.push({path: '/blogDetail/' + id});
    },
    init() {
      this.searchBlog({author: this.userInfo.code})
      this.searchBlogSummary({author: this.userInfo.code})
    },
    followEvent(id) {
      UserEventRequest.add({id: id, event: '7', target: 'USER'}).then(res => {
        if (res.status === 200) {
          this.followed = true
        }
      })
    },
  },
  watch: {
    '$store.state.screenWidth': function (newVal) {
      this.onMobile = newVal < 576
    },
  },
  created() {
    if (!this.$route.params.code || this.$store.state.userInfo.code == this.$route.params.code) {
      this.userInfo = this.$store.state.userInfo
      this.currentUser = true;
      this.init()
    } else {
      UserInfoRequest.getUserOpenData(this.$route.params.code).then(res => {
        if (res.status == '200') {
          this.userInfo = res.data.data
          if (this.userInfo && this.userInfo.id) {
            UserEventRequest.check({action: '7', targetType: '5', targetId: this.userInfo.id}).then(res => {
              if (res.status == '200') {
                this.followed = res.data.data
              }
            })
          }
        }
        this.init()
      })
      this.currentUser = false;
    }
  }
}
</script>

<style>

.personal-container {
  overflow: auto;
  height: 100%;
}

.personal-container::-webkit-scrollbar {
  /*隐藏滚动条*/
  display: none;
}

.personal-container .ant-spin-nested-loading {
  position: relative;
  height: 600px;
}

.personal-summary-container {
  margin: 20px 0;
}

.personal-summary-container .ant-layout-header {
  height: 60px;
  padding: 0 10px;
  line-height: 64px;
  background: rgb(255, 255, 255);
  border-bottom: inset;
}

.personal-summary-container .ant-layout-content {
  overflow: auto;
  height: 360px;
}

.personal-summary-container .ant-layout-content::-webkit-scrollbar {
  /*隐藏滚动条*/
  display: none;
}

</style>